import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useGetProfileQuery } from "../../app/features/apiSlice";
import { setUserData } from "../../app/features/DataSlice";

const ProfileLoader = ({ setHasInvestment }) => {
  const dispatch = useDispatch();
  const sessionId = React.useRef(Date.now()).current;
  const { data, isSuccess } = useGetProfileQuery({ sessionId });

  useEffect(() => {
    if (isSuccess) {
      const user = {
        ...data?.user,
        type: data?.orgUser?.type,
        company: data?.orgUser?.company_name,
      };

      // redux update
      dispatch(setUserData(user));

      // Check if user has purchased any plan (X-PLAN or X-ONE)
      // Check if user has purchased X-PLAN specifically
      const hasXPlan = data?.plan?.length > 0;
      // Check if user has purchased X-ONE specifically
      const hasXOne = data?.heliorOne?.length > 0;
      // Show KYC card if either X-PLAN or X-ONE is purchased
      setHasInvestment(hasXPlan || hasXOne);
    }
  }, [isSuccess, data, dispatch, setHasInvestment]);

  return null;
};

export default ProfileLoader;
